import { Directive, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { UndoClickService } from 'src/app/shared/services/undo-click.service';

@Directive({
    selector: '[undoClick]',
})
export class UndoClickDirective {
    @Output('onUndoClick') onUndoClick: EventEmitter<Event> = new EventEmitter();
    @Input('targets') targets: HTMLElement[] = [];

    protected eventSubscription: Subscription = null;

    constructor(
        private elementRef: ElementRef,
        private undoClickService: UndoClickService,
    ) { }

    ngOnInit(): void {
        this.eventSubscription = this.undoClickService.onClickEvent().subscribe(event => {
            if (!event?.target || !this.elementRef?.nativeElement) {
                return;
            }

            event && event?.stopPropagation();

            if (!this.elementRef.nativeElement.contains(event.target)
                && !this.targets?.filter(target => target?.contains(event.target as HTMLElement)).length
            ) {
                this.onUndoClick.emit(event);
            }
        });
    }

    ngOnDestroy(): void {
        this.eventSubscription && this.eventSubscription.unsubscribe();
    }
}
